import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    optionalString,
    requiredString,
    SYNC_UPDATE_VALIDATION_SCHEMA,
    timestamp,
} from './common';

export const createShoppingListAddSchema = () =>
    z
        .object({
            id: requiredString,
            user_id: requiredString,
            organisation_id: requiredString,
            name: requiredString,
            added_to_inventory_time: optionalString,
            sent_to_dealer_time: optionalString,
            requested_sending_to_dealer_time: optionalString,
            dealer_id: optionalString,
            created_at: timestamp,
            updated_at: timestamp,
        })
        .strict();

export const createShoppingListUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createShoppingListAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.shopping_lists,
    );

export const createShoppingListDeleteSchema = () => createDeleteSchema();

export const createShoppingListSchemas = () => ({
    add: createShoppingListAddSchema(),
    update: createShoppingListUpdateSchema(),
    delete: createShoppingListDeleteSchema(),
});

export const shoppingListRawRecordSchema = createShoppingListAddSchema();
